import { useState } from "react";
import styles from "./Buscador.module.scss";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { PerfilUsuario } from "shared/contexts/Auth/AuthContext";

export interface BuscadorProps {
  placeholder?: string;
  autoSearchOnEnter?: boolean;
  navigateTo?: string;
  value?: string;
  onChange?: (value: string) => void;
  perfilAtivo?: PerfilUsuario;
}

export const Buscador: React.FC<BuscadorProps> = ({
  placeholder = "Busque produtos ou lojas",
  autoSearchOnEnter = true,
  navigateTo = "/listarprodutos",
  value,
  onChange,

  // NOVO
  perfilAtivo = "comprador",
}) => {
  const [termoBusca, setTermoBusca] = useState("");

  const navigate = useNavigate();

  const termoAtual =
    value !== undefined
      ? value
      : termoBusca;

  /*
   * =========================================
   * BUSCAR
   * =========================================
   */

  function handleSearch() {
    const termo = termoAtual.trim();

    if (!termo) {
      navigate(navigateTo);
      return;
    }

    navigate(
      `${navigateTo}?search=${encodeURIComponent(termo)}`
    );
  }

  /*
   * =========================================
   * ENTER
   * =========================================
   */

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (
      event.key === "Enter" &&
      autoSearchOnEnter
    ) {
      event.preventDefault();

      handleSearch();
    }
  };

  /*
   * =========================================
   * CLASSE DO PERFIL
   * =========================================
   */

  const classePerfil =
    perfilAtivo === "vendedor"
      ? styles.buscaVendedor
      : styles.buscaComprador;

  return (
    <div
      className={`${styles.pesquisaContainer} ${classePerfil}`}
    >
      {/* LUPA DESKTOP */}

      <Search
        size={17}
        className={styles.pesquisaIconDesktop}
      />

      {/* INPUT */}

      <input
        className={styles.pesquisaInput}
        placeholder={placeholder}
        value={termoAtual}
        onChange={(e) => {
          const valor = e.target.value;

          if (onChange) {
            onChange(valor);
          } else {
            setTermoBusca(valor);
          }
        }}
        onKeyDown={handleKeyDown}
      />

      {/* LUPA MOBILE */}

      <Search
        size={18}
        className={styles.pesquisaIconMobile}
        onClick={handleSearch}
      />

      {/* BOTÃO DESKTOP */}

      <button
        type="button"
        className={styles.btnBuscar}
        onClick={handleSearch}
      >
        Buscar
      </button>
    </div>
  );
};